import * as React from "react";
import {formatXAxisPeriodToYearForPlanMarketValue, getAxisValueScale} from "../../utils/chartUtils";
import {HorizontalBarChart, IHorizontalBarChartProps} from "../common/HorizontalBarChart.component";
import {formatCurrency} from "../../utils/numberUtil";

export const PlanCashFlowBarChart: React.FunctionComponent<IHorizontalBarChartProps> = (props) => {
    const dataScale = getAxisValueScale(props.data.map(it => it.value!));

    const chartValueFormatFunction = (value: number | string) => {
        if (typeof value === "string") {
            return value;
        }
        return `${formatCurrency(value, 0)}`;
    };

    return <div className="plan-cash-flow-chart__container" data-testid="plan-cash-flow-chart__container">
        <h3>Net Cash Flows</h3>
        <div className="plan-cash-flow-chart__sub-title">
            {`Total net cash flows in ${dataScale === 1000 ? "Thousands" : "Millions"}`}
        </div>
        <HorizontalBarChart
            data={props.data}
            tooltipLabel={"Net Cash Flow: "}
            valueFormatFunction={chartValueFormatFunction}
            xAxisFormater={formatXAxisPeriodToYearForPlanMarketValue}
            yAxisFormater={value => formatCurrency(value / dataScale, 0)}
        />
    </div>;
};